import React from 'react';
import {
  StyledLabel
} from './ui';

const Label = (props) => {
  const {
    label,
    half,
    tight,
    children,
    ...rest,
  } = props;
  return (
    <StyledLabel half={half} tight={tight}>
      <label {...rest}>{label}</label>
      {children}
    </StyledLabel>
  );
};

export default Label;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/Label.js